import restaurantInstance from '../instance'

const getPresetDiscounts = () => {
	return restaurantInstance.get('/presetDiscounts')
}

export default getPresetDiscounts
